/**
 * Rechargement automatique des images dont l'URL signée a expiré.
 *
 * Étape 4 (21/09) : les médias (/avatar/, /cover/, /logo/, /public-photos/,
 * /tasks/, feed-media/) ne sont plus servis en anonyme nu — chaque <img>
 * charge une URL signée, valable entre 1 h et 1 h 15. Un onglet resté ouvert
 * au-delà voit ses images échouer (404). Ce module écoute les erreurs d'<img>
 * au niveau de la fenêtre (phase de capture : l'événement `error` ne bulle
 * pas), demande à l'API une signature fraîche via GET /medias/signature —
 * mêmes gardes société/authentification que le service du fichier — et
 * recharge l'image en place.
 *
 * UNE SEULE tentative par élément (data-resignee) : si l'URL fraîche échoue
 * aussi, le fichier n'existe plus ou n'appartient pas à l'utilisateur, et on
 * ne veut pas d'une boucle 404 → re-signature → 404.
 *
 * Installé une fois au démarrage (src/index.js). Les pages publiques sans
 * compte (PortailSuivi, PublicMaintenanceTracking) n'ont pas de jeton : on ne
 * tente rien — leurs URLs redeviennent fraîches au rechargement de la page.
 */
import { api, tokens } from "./api";
import { resolveUrl } from "./avatar";

const MARQUE = "resignee";

/** Extrait la clé de stockage d'un src d'<img> signé, ou null. */
export function cleDepuisSrc(src) {
  if (typeof src !== "string") return null;
  const i = src.indexOf("/api/uploads/");
  if (i === -1) return null;
  const reste = src.slice(i + "/api/uploads/".length);
  if (!reste.includes("sig=")) return null; // jamais signée : rien à rafraîchir
  const cle = reste.split("?", 1)[0];
  return cle || null;
}

async function rechargeImage(img) {
  const cle = cleDepuisSrc(img.src);
  if (!cle) return;
  if (img.dataset[MARQUE]) return; // une seule tentative
  img.dataset[MARQUE] = "1";
  if (!tokens.access) return; // page publique sans compte : rien à demander
  try {
    const { data } = await api.get("/medias/signature", { params: { cle } });
    if (data?.url && img.isConnected) {
      img.src = resolveUrl(data.url);
    }
  } catch {
    // L'API a refusé (fichier disparu, autre société, session close) :
    // on laisse l'image en l'état, le composant affiche son repli.
  }
}

let installe = false;

export function installeRechargementImagesSignees() {
  if (installe || typeof window === "undefined") return;
  installe = true;
  window.addEventListener(
    "error",
    (evenement) => {
      const cible = evenement.target;
      if (cible instanceof HTMLImageElement) rechargeImage(cible);
    },
    true, // capture : `error` d'un <img> ne bulle pas
  );
}
